import {
  FETCH_STICK_PRICE,
  FETCH_STICK_PRICE_SUCCEED,
  FETCH_STICK_PRICE_FAILED,
  FETCH_LATEST_PRICE,
  FETCH_LATEST_PRICE_SUCCEED,
  FETCH_LATEST_PRICE_FAILED,
  FETCH_PRICE_24H,
  FETCH_PRICE_24H_SUCCEED,
  FETCH_PRICE_24H_FAILED,
  FETCH_ALL_LATEST_PRICE,
  FETCH_ALL_LATEST_PRICE_SUCCEED,
  FETCH_ALL_LATEST_PRICE_FAILED,
  FETCH_PRICE_MARKET_24H,
  FETCH_PRICE_MARKET_24H_SUCCEED,
  FETCH_PRICE_MARKET_24H_FAILED,

} from './action_types';

export default {
  fetchStickPriceAction: (data) => ({
    type: FETCH_STICK_PRICE,
    params: {
      data,
    },
  }),
  fetchStickPriceActionSucceed: (data) => ({
    type: FETCH_STICK_PRICE_SUCCEED,
    params: {
      data,
    },
  }),
  fetchStickPriceActionFailed: (err) => ({
    type: FETCH_STICK_PRICE_FAILED,
    err,
  }),

  fetchLatestPriceAction: (data) => ({
    type: FETCH_LATEST_PRICE,
    params: {
      data,
    },
  }),
  fetchLatestPriceActionSucceed: (data) => ({
    type: FETCH_LATEST_PRICE_SUCCEED,
    params: {
      data,
    },
  }),
  fetchLatestPriceActionFailed: (err) => ({
    type: FETCH_LATEST_PRICE_FAILED,
    err,
  }),

  fetchPrice24hAction: (data) => ({
    type: FETCH_PRICE_24H,
    params: {
      data,
    },
  }),
  fetchPrice24hActionSucceed: (data) => ({
    type: FETCH_PRICE_24H_SUCCEED,
    params: {
      data,
    },
  }),
  fetchPrice24hActionFailed: (err) => ({
    type: FETCH_PRICE_24H_FAILED,
    err,
  }),

  fetchAllLatestPriceAction: (data) => ({
    type: FETCH_ALL_LATEST_PRICE,
    params: {
      data,
    },
  }),
  fetchAllLatestPriceActionSucceed: (data) => ({
    type: FETCH_ALL_LATEST_PRICE_SUCCEED,
    params: {
      data,
    },
  }),
  fetchAllLatestPriceActionFailed: (err) => ({
    type: FETCH_ALL_LATEST_PRICE_FAILED,
    err,
  }),

  fetchPriceMarket24h: (data) => ({
    type: FETCH_PRICE_MARKET_24H,
    params: {
      data,
    },
  }),
  fetchPriceMarket24hSucceed: (data) => ({
    type: FETCH_PRICE_MARKET_24H_SUCCEED,
    params: {
      data,
    },
  }),
  fetchPriceMarket24hFailed: (err) => ({
    type: FETCH_PRICE_MARKET_24H_FAILED,
    err,
  }),
};
